import { render, staticRenderFns } from "./CustomTransition.vue?vue&type=template&id=36f41467&scoped=true"
import script from "./CustomTransition.vue?vue&type=script&lang=js"
export * from "./CustomTransition.vue?vue&type=script&lang=js"
import style0 from "./CustomTransition.vue?vue&type=style&index=0&id=36f41467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f41467",
  null
  
)

export default component.exports